"use client";

import { DealType } from "@/enums/dealType";
import { PropertyType } from "@/enums/propertyType";

/**
 * Helper function to safely convert dealType to DealType enum
 */
export const getSafeDealType = (dealType: DealType | string): DealType => {
  if (
    typeof dealType === "string" &&
    Object.values(DealType).includes(dealType as DealType)
  ) {
    return dealType as DealType;
  }
  return DealType.PRIMARY;
};

/**
 * Helper function to safely convert property type to PropertyType enum
 */
export const getSafePropertyType = (
  propertyType: unknown,
): PropertyType | undefined => {
  return typeof propertyType === "string"
    ? (propertyType as PropertyType)
    : undefined;
};

/**
 * Helper function to find a key in an enum by its value
 */
export const findEnumKeyByValue = <T extends Record<string, string | number>>(
  enumObj: T,
  value: string | number,
): string | undefined => {
  return Object.keys(enumObj).find((key) => enumObj[key as keyof T] === value);
};

/**
 * Helper function to safely get the first element of an array or return the value itself
 */
export const getSafeObjectType = (objectType: unknown): string => {
  if (objectType && Array.isArray(objectType)) {
    return objectType[0] as string;
  }
  return objectType as string;
};
